// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3jA5w","calendarButtons":"ClockData_calendarButtons__fpE9d"};